import { c as _c } from "react/compiler-runtime";
import { HeroImage } from '../../GiftDetailHeader/_components/HeroImage';
interface MobileHeroProps {
  heroImageUrlList: string[];
  adultYN: boolean;
}
export const MobileHero = t0 => {
  const $ = _c(3);
  const {
    heroImageUrlList,
    adultYN
  } = t0;
  let t1;
  if ($[0] !== adultYN || $[1] !== heroImageUrlList) {
    t1 = <div className="hidden mobile:block tablet:block"><HeroImage heroImageUrlList={heroImageUrlList} adultYN={adultYN} /></div>;
    $[0] = adultYN;
    $[1] = heroImageUrlList;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};